import { FormattedMessage as FM } from "react-intl";

import { PlusIcon } from "components/Icons";

function ToolButton({ action, label, handleAction }) {
  return (
    <button
      key={"toolbutton"}
      className="flex bg-sky-950 h-10 hover:bg-sky-800 active:scale-95 py-2 px-4 rounded-md shadow-lg transform duration-75"
      onClick={() => handleAction(action)}
    >
      <PlusIcon className="my-auto mx-auto text-neutral-100 w-5 h-5 fill-current" />
      <span className="text-md text-neutral-100 my-auto">
        <FM id={`board.${label}`} />
      </span>
    </button>
  );
}

export default ToolButton;
